import React, { useMemo, useRef } from 'react';
import { NoData, Skelton } from 'src/@vymo/ui/blocks';
import { Form } from 'src/@vymo/ui/molecules';
import { FormVersion } from 'src/@vymo/ui/molecules/form/types';
import classnames from 'classnames';
import { Keys, locale } from 'src/i18n';
import { getDetails } from 'src/models/details/selectors';
import { getRevyreConfig } from 'src/models/lmsConfig/selectors';
import { useAppSelector } from 'src/store/hooks';
import { TAB_STATUS_KEYS } from '../../constant';
import { getStatus } from '../../selector';
import { getBeforeSaveHookConfig, getEntityInputsAndGroups } from './queries';
import styles from '../../index.module.scss';

function EntityDetails(props) {
  const formRef = useRef(null);
  const { entityId } = props;
  const details = useAppSelector((state) => getDetails(state, entityId));
  const detailsWorkflow = details?.inputsMap?.workflowType;
  const revyreConfig = useAppSelector(getRevyreConfig);

  const status = useAppSelector((state) =>
    getStatus(state, TAB_STATUS_KEYS.DETAILS),
  );

  const { inputs, groups, formValues } = useMemo(
    () => getEntityInputsAndGroups(props, details, revyreConfig),
    [details, props, revyreConfig],
  );

  const workflowEvents = revyreConfig?.[detailsWorkflow]?.events?.map(
    (item) => ({ ...item, code: item?.allowedAction, name: item?.actionName }),
  );

  return (
    <div className={styles.detailsWrapper__detailsBody__details}>
      {status === 'loading' && <Skelton rounded lines={8} />}
      {Boolean(status === 'done' && !inputs.length) && (
        <NoData message={locale(Keys.ENTITY_DETAILS_NOT_FOUND)} />
      )}
      {Boolean(status === 'done' && inputs?.length > 0) && (
        <Form
          ref={formRef}
          id="doDetailsForm"
          name="doDetailsForm"
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          onChange={(formFields) => {}}
          className={classnames(
            styles.detailsWrapper__detailsBody__details__form,
            {
              [styles.detailsWrapper__detailsBody__details__form__noGroup]:
                !groups.length,
            },
          )}
          config={{
            version: FormVersion.webRevyre,
            data: inputs,
            grouping: groups,
            seperator: ':',
            fieldItemConfig: {
              showDisabledIcon: true,
            },
            groupConfig: {
              collapsibleClasses:
                styles.detailsWrapper__detailsBody__details__form__accordion,
            },
            customPayload: {
              entityNextEventOptions: workflowEvents,
            },
            ...getBeforeSaveHookConfig(props),
            viewMode: true,
          }}
          value={formValues}
        />
      )}
      {status === 'error' && (
        <NoData message={locale(Keys.ENTITY_DETAILS_NOT_FOUND)} />
      )}
    </div>
  );
}

export default EntityDetails;
